const translations = {
  "en": {
    "~Preview %{var0}~": "~Preview %{var0}~",
    "Preview %{var0}": "Preview %{var0}",
    "Remove %{var0}": "Remove %{var0}",
    "Upload failed": "Upload failed",
    "Uploading...": "Uploading..."
  },
  "zh-tw": {
    "~Preview %{var0}~": "Preview %{var0}",
    "Preview %{var0}": "預覽 %{var0}",
    "Remove %{var0}": "移除 %{var0}",
    "Upload failed": "上傳失敗",
    "Uploading...": "上傳中..."
  }
};

export default translations;
